import { useAppStore } from '../../useAppStore.ts';
import { PostSerialResponse } from '../../queries/useGetSerialNumber.ts';
import { clearAlternateLogo } from '@luna-protocol/core/src/utils/constants/branding.ts';

const useClearSessionData = () => {
  const setFloorplanDetails = useAppStore(state => state.setFloorplanDetails);

  const clearSessionData = () => {
    // clear session data before opening a new application, in case we have old data in session
    sessionStorage.clear();
    // clear context data
    setFloorplanDetails(new Map<string, PostSerialResponse>());
    clearAlternateLogo();
  };

  return clearSessionData;
};

export default useClearSessionData;
